export default function (state, payload) {
  return {
    ...state,
    filterMyAbteilung: payload.filterMyAbteilung,
    myAbteilungen: payload.myAbteilungen,
  }
}
